import React from "react";
import Page from "./Page";
import "./AssessPage.scss"; // Assuming you have a CSS file for styles
import { useTranslation } from "react-i18next";
const AssessDetail = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <>
        <section className="money-section">
          <div className="assssbanner">
            <img
              src="/images/finwell-img/Header.png"
              alt="banner"
              width="1440"
              height="244"
              className="img-fluid"
            />
          </div>
          <div className="money-section-inner">
            <div class="card-money">
              <h1 aria-label="Money Compass">{t("money_compass")}</h1>
              <p className="mb-0">
                A quick, guided check-in to help you understand where you are
                financially and how to move forward.
              </p>
              <p className="mb-0">
                You'll get tailored suggestions—like Action Paths, coaching
                tips, and tools—based on your goals, habits, and confidence
                level.
              </p>

              <p className="mt-4 mb-0">
                Takes just 2 minutes. Quick and easy, no prep needed.
              </p>
              <div className="btnsec d-flex gap-1 align-items-center justify-content-between mt-4">
                <button
                  className="session-btn mt-0"
                  tabIndex={0}
                  aria-label="Start money compass"
                >
                  Start money compass
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.58 7.50399L9.076 1.98399C8.98 1.88799 8.932 1.77065 8.932 1.63199C8.932 1.49332 8.98 1.37599 9.076 1.27999C9.172 1.18399 9.28933 1.13599 9.428 1.13599C9.56667 1.13599 9.684 1.18399 9.78 1.27999L16.5 7.99999L9.78 14.72C9.684 14.816 9.56667 14.864 9.428 14.864C9.28933 14.864 9.172 14.816 9.076 14.72C8.98 14.624 8.932 14.5067 8.932 14.368C8.932 14.2293 8.98 14.112 9.076 14.016L14.58 8.49599H0.996C0.857333 8.49599 0.74 8.44799 0.644 8.35199C0.548 8.25599 0.5 8.13865 0.5 7.99999C0.5 7.86132 0.548 7.74399 0.644 7.64799C0.74 7.55199 0.857333 7.50399 0.996 7.50399H14.58Z"
                      fill="white"
                    />
                  </svg>
                </button>
                <button
                  className="border-0 link-btn"
                  tabIndex={0}
                  aria-label="Take assessment later"
                >
                  Take assessment later
                </button>
              </div>
            </div>
          </div>
        </section>
      </>
    </Page>
  );
};

export default AssessDetail;
